import { Box, Flex, Grid, GridItem, Select, Text } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";

import GreenButton from "components/Buttons/GreenButton";
import MainColorButton from "components/Buttons/MainColorButton";
import PrimaryButton from "components/Buttons/PrimaryButton";
import EDateRangePicker from "components/EDateRangePicker";
import EInput from "components/EInput";
import ESelect from "components/ESelect";
import FullPageLoader from "components/Loading/FullPageLoading";
import ModalConfirm from "components/modals/ModalConfirm";
import {
  SEARCH_EMPLOYEE_TYPE_DATE_PICKER,
  SEARCH_EMPLOYEE_TYPE_SELECT,
  SEARCH_EMPLOYEE_TYPE_INPUT,
  EMPLOYEE_GROUP_REGISTERED_EMPLOYMENT_TYPE_CODES,
  EMPLOYEE_GROUP_BUSSINESS_EMPLOYMENT_TYPE_CODES,
  EMPLOYEE_GROUP_BUSSINESS_JOB_CODES,
  EMPLOYEE_GROUP_OTHER_BUSSINESS_EMPLOYMENT_TYPE_CODES,
  PERSONAL_TARGET_GROUPS,
  EMPLOYEE_GROUP_OTHER_BUSSINESS_JOB_CODES,
  EMPLOYEE_TARGET_GROUP_BUSSINESS,
  EMPLOYEE_TARGET_GROUP_OTHER_BUSSINESS,
  EMPLOYEE_TARGET_GROUP_DEPARTMENT_2,
  EMPLOYEE_TARGET_GROUP_DEPARTMENT_2_JOB,
  FORMAT_DATE_PLACEHOLDER,
} from "constants";
import { useRandomAssignCourse } from "hooks/useEmployee";
import { useModalState } from "hooks/useModalState";
import { t } from "i18next";
import { filterOnlyEnableEmployee } from "utils";
import { useEmployeeStore } from "store/employeeStore";

const SearchEmployeeForm = (props) => {
  const {
    inputList,
    methods,
    col,
    submitAndClose,
    handleSubmit,
    enableTargetGroup,
    selectedData,
    isModal,
    formKeys = [],
    handleResetListCourse,
    handleSearchEmployeeDefault,
    isHideSubmitAndClose = false,
    onChangeGroup = () => {},
    setEmployeeIdsCheckedState,
  } = props;
  const history = useHistory();
  const [groupValue, setGroupValue] = useState(null);
  const [enableSearch, setEnableSearch] = useState(
    enableTargetGroup ? false : true
  );
  const [isClearParamSearch, setIsClearParamSearch] = useState(false);
  const [isClearListEmployee, setIsClearListEmployee] = useState(false);

  const mutationRandomAssignCourse = useRandomAssignCourse();

  const { modalState, open, close, closeAll } = useModalState({
    modalConfirmAssign: false,
  });

  const { searchedEmployees, allEmployees } = useEmployeeStore((state) => state);
  const { setSearchedEmployees, setIsShowSearchData } = useEmployeeStore();

  /**
   * Check if a field should be disabled based on the selected group
   * @param {string} fieldName - The name of the field (or nameFrom for date picker)
   * @param {string} nameTo - Optional nameTo for date picker
   * @returns {boolean} - True if the field should be disabled
   */
  const isFieldDisabled = (fieldName, nameTo = null) => {
    if (!enableSearch) return true;
    
    // If group is "第2階層" (10), only enable department_2_codes
    if (+groupValue === EMPLOYEE_TARGET_GROUP_DEPARTMENT_2) {
      // For date pickers, check both nameFrom and nameTo
      if (nameTo) {
        return fieldName !== 'department_2_codes' && nameTo !== 'department_2_codes';
      }
      return fieldName !== 'department_2_codes';
    }
    
    // If group is "第2階層・職種" (11), only enable department_2_codes and job_codes
    if (+groupValue === EMPLOYEE_TARGET_GROUP_DEPARTMENT_2_JOB) {
      // For date pickers, check both nameFrom and nameTo
      if (nameTo) {
        return fieldName !== 'department_2_codes' && fieldName !== 'job_codes' && 
               nameTo !== 'department_2_codes' && nameTo !== 'job_codes';
      }
      return fieldName !== 'department_2_codes' && fieldName !== 'job_codes';
    }
    
    return false;
  };

  /**
   * Handle data select for personal training
   *
   * @param {*} inputName
   * @param {*} data
   * @returns
   */
  const handleDataSelect = (inputName, data) => {
    if (!groupValue) {
      return data;
    }
    
    if (+groupValue === EMPLOYEE_TARGET_GROUP_BUSSINESS) {
      if (inputName === 'employment_type_code') {
        return [{ id: "", name: "" }, ...data.filter((item) => EMPLOYEE_GROUP_BUSSINESS_EMPLOYMENT_TYPE_CODES.includes(item.code))];
      } else if (inputName === 'job_codes') {
        return [{ id: "", name: "" }, ...data.filter((item) => EMPLOYEE_GROUP_BUSSINESS_JOB_CODES.includes(item.code))];
      } else {
        return data;
      }
    } else if (+groupValue === EMPLOYEE_TARGET_GROUP_OTHER_BUSSINESS) {
      if (inputName === 'employment_type_code') {
        return [{ id: "", name: "" }, ...data.filter((item) => EMPLOYEE_GROUP_OTHER_BUSSINESS_EMPLOYMENT_TYPE_CODES.includes(item.code))];
      } else if (inputName === 'job_codes') {
        return [{ id: "", name: "" }, ...data.filter((item) => EMPLOYEE_GROUP_OTHER_BUSSINESS_JOB_CODES.includes(item.code))];
      } else {
        return data;
      }
    } else {
      if (inputName === 'employment_type_code') {
        return [{ id: "", name: "" }, ...data.filter((item) => EMPLOYEE_GROUP_REGISTERED_EMPLOYMENT_TYPE_CODES.includes(item.code))];
      }
      return data;
    }
  };


  const handleRandomAssign = () => {
    const formValue = methods.getValues();
    const currentGroupValue = formValue.employee_group;

    mutationRandomAssignCourse.mutate({
      employee_ids: selectedData,
      group_type: currentGroupValue,
      target_group_id: currentGroupValue,
      department_2_codes: Array.isArray(formValue?.department_2_codes) 
        ? formValue.department_2_codes.filter(Boolean).map((item) => Number(item))
        : formValue?.department_2_codes 
        ? [Number(formValue.department_2_codes)]
        : [],
      job_codes: Array.isArray(formValue?.job_codes) 
        ? formValue.job_codes.filter(Boolean).map((item) => Number(item))
        : formValue?.job_codes 
        ? [Number(formValue.job_codes)]
        : [],
    });
    close("modalConfirmAssign");
  };

  const handleSetGroupSelection = (e) => {
    // when change employee_group
    if ((groupValue !== e?.target?.value)) {
      setIsClearParamSearch(true);
    };

    // clear data search when change employee_group
    if ((groupValue && !e?.target?.value)) {
      setIsClearListEmployee(true);
    };

    setGroupValue(e?.target?.value ?? null)
  };


  const handleSetGroup = () => {
    methods.setValue("employee_group", groupValue);
    setEnableSearch(!!groupValue);

    // For "第2階層" (10) or "第2階層・職種" (11), ensure work_status = 1 is set
    const isDepartment2Group = +groupValue === EMPLOYEE_TARGET_GROUP_DEPARTMENT_2 || 
                                +groupValue === EMPLOYEE_TARGET_GROUP_DEPARTMENT_2_JOB;

    // clear from key when click change employee_group value
    formKeys.map((formKey) => {
      if (formKey === "employee_group") return;
      // when change group value, is set to work_status = 1
      if (formKey === "work_status") {
        methods.setValue(formKey, "1");
        return;
      };
      methods.setValue(formKey, "");
    });

    setIsClearParamSearch(false);
    setIsClearListEmployee(false);

    if (groupValue) {
      onChangeGroup(groupValue);
    };

    // when selection employee_group == default is null
    if (isClearListEmployee && isClearParamSearch) {
      handleSearchEmployeeDefault();
      return;
    }

    // For department 2 groups, ensure work_status = 1 is included in API call
    if (isClearParamSearch) {
      handleResetListCourse();
      if (isDepartment2Group) {
        // For department 2 groups, ensure work_status = 1 is included
        // Use setTimeout to ensure form values are updated before submission
        setTimeout(() => {
          // Ensure work_status = 1 is set in form
          methods.setValue("work_status", "1", { shouldValidate: false });
          // Call handleSubmit which will use the updated form values including work_status = 1
          handleSubmit();
        }, 0);
      } else {
        handleSubmit({});
      }
      return;
    }

    // For department 2 groups, ensure work_status = 1 is included
    if (isDepartment2Group) {
      // Ensure work_status = 1 is set, then submit with form values
      setTimeout(() => {
        methods.setValue("work_status", "1", { shouldValidate: false });
        handleSubmit();
      }, 0);
    } else {
      handleSubmit();
    }
  };


  useEffect(() => {
    if (mutationRandomAssignCourse.isLoading) {
      setTimeout(() => {
        // Currently, employees who were random assigned are not removed from the list (old logic)
        if (setEmployeeIdsCheckedState) {
          setEmployeeIdsCheckedState(
            filterOnlyEnableEmployee(searchedEmployees).map(
              (employee) => employee.id
            )
          );
        }
      }, 500);
    }
  }, [mutationRandomAssignCourse.isLoading]);

  const handleFormSubmit = (e) => {
    handleSubmit(e);
  };

  return (
    <form onSubmit={handleFormSubmit}>
      {mutationRandomAssignCourse.isLoading && <FullPageLoader />}
      {enableTargetGroup && (
        <Grid
          templateColumns={{
            base: "repeat(1, 1fr)",
            md: `repeat(${col}, 1fr)`,
          }}
          gap="10px"
          mb="20px"
        >
          <GridItem colSpan={2}>
            <Flex pl="50px">
              <Box
                w={"100px"}
                textAlign={"right"}
                marginRight={"5px"}
                marginTop={"4px"}
              >
                <Text fontSize={"14px"}>
                  {t("pages.random_assign_course.target_group")}
                </Text>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Select
                  style={{ height: "30px", fontSize: "14px" }}
                  placeholder={t("common.option.placeholder")}
                  onChange={handleSetGroupSelection}
                >
                  {PERSONAL_TARGET_GROUPS.map((group) => (
                    <option value={group.id} key={group.id}>
                      {group.name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box ml="10px">
                <PrimaryButton
                  text={t("common.confirm")}
                  onClick={handleSetGroup}
                />
              </Box>
            </Flex>
          </GridItem>
          <GridItem textAlign="center">
            <Flex justifyContent="center">
              <MainColorButton
                text={t("pages.random_assign_course.allocate_course")}
                onClick={() => open("modalConfirmAssign")}
                disabled={!selectedData?.length}
              />
              <Box ml="10px">
                <PrimaryButton
                  text={t("pages.courses.create_new")}
                  onClick={() =>
                    history.push("individual-training/courses/create")
                  }
                />
              </Box>
            </Flex>
          </GridItem>
        </Grid>
      )}

      <Grid
        templateColumns={{ base: "repeat(1, 1fr)", md: `repeat(${col}, 1fr)` }}
        gap="4px"
      >
        {inputList.map((inputItem, index) => {
          const fieldDisabled = isFieldDisabled(inputItem.name);
          switch (inputItem.type) {
            case SEARCH_EMPLOYEE_TYPE_INPUT:
              return (
                <SearchInput
                  label={inputItem.label}
                  name={inputItem.name}
                  control={methods.control}
                  disabled={fieldDisabled}
                  key={index}
                />
              );
            case SEARCH_EMPLOYEE_TYPE_SELECT:
              return (
                <SearchSelect
                  label={inputItem.label}
                  name={inputItem.name}
                  control={methods.control}
                  setValue={methods.setValue}
                  data={
                    isModal
                      ? inputItem.data
                      : handleDataSelect(inputItem.name, inputItem.data)
                  }
                  disabled={fieldDisabled}
                  key={index}
                />
              );
            case SEARCH_EMPLOYEE_TYPE_DATE_PICKER:
              const datePickerDisabled = isFieldDisabled(inputItem.nameFrom, inputItem.nameTo);
              return (
                <SearchDateRange
                  label={inputItem.label}
                  nameTo={inputItem.nameTo}
                  nameFrom={inputItem.nameFrom}
                  methods={methods}
                  disabled={datePickerDisabled}
                  key={index}
                />
              );
            default:
              return <></>;
          }
        })}
      </Grid>
      <Flex alignItems={"center"} mt={"10px"} justifyContent={"end"}>
        {!isHideSubmitAndClose && (
          <Box mr={"10px"}>
            <PrimaryButton
              disabled={!enableSearch}
              text={t("pages.course_form.add_member")}
              onClick={submitAndClose}
            />
          </Box>
        )}

        <Box>
          <GreenButton
            disabled={!enableSearch}
            text={t("pages.course_form.search")}
            type="submit"
          />
        </Box>

        <ModalConfirm
          isOpen={modalState.modalConfirmAssign}
          content={t("pages.random_assign_course.title_modal")}
          onClose={() => close("modalConfirmAssign")}
          onSubmit={handleRandomAssign}
          titleBtnClose={t("pages.random_assign_course.btn_cancel")}
          titleBtnOk={t("pages.random_assign_course.btn_ok")}
        />
      </Flex>
    </form>
  );
};

const SearchInput = (props) => {
  const { label, name, placeholder, control, disabled } = props;

  return (
    <GridItem key={name}>
      <Flex marginTop="5px">
        <Box w={"100px"} textAlign={"right"} marginRight={"5px"} marginTop={"4px"}>
          <Text fontSize={"14px"}>{t(label)}</Text>
        </Box>
        <Box sx={{ flex: 1 }}>
          <EInput
            name={name}
            placeholder={placeholder ?? ""}
            control={control}
            style={{ h: "30px" }}
            disabled={disabled}
          />
        </Box>
      </Flex>
    </GridItem>
  );
};

const SearchSelect = (props) => {
  const { label, name, placeholder, data, control, disabled, setValue } = props;
  const isMultiSelect = name === 'department_2_codes' || name === 'job_codes';
  return (
    <GridItem key={name}>
      <Flex marginTop={ name === 'department_2_codes' ? "0px" : "5px" }>
        <Box w={"100px"} textAlign={"right"} marginRight={"5px"} marginTop={"4px"}>
          <Text fontSize={"14px"}>{t(label)}</Text>
        </Box>
        <Box sx={{ flex: 1 }}>
          <ESelect
            style={{ h: "30px" }}
            name={name}
            placeholder={placeholder ?? ""}
            control={control}
            dataSelect={data}
            disabled={disabled}
            isMulti={isMultiSelect}
          />
        </Box>
      </Flex>
    </GridItem>
  );
};

const SearchDateRange = (props) => {
  const { label, nameTo, nameFrom, methods, disabled } = props;

  return (
    <GridItem key={`${nameFrom}${nameTo}`} colSpan={2}>
      <Flex marginTop="5px">
        <Box w={"100px"} textAlign={"right"} marginRight={"5px"} marginTop={"4px"}>
          <Text fontSize={"14px"}>{t(label)}</Text>
        </Box>
        <Flex sx={{ flex: 1 }}>
          <Box sx={{ flex: 1 }}>
            <EDateRangePicker
              style={{ h: "30px" }}
              disabled={disabled}
              placeholder={FORMAT_DATE_PLACEHOLDER}
              dateFormat="yyyy-MM-dd"
              setValue={methods.setValue}
              control={methods.control}
              name={nameFrom}
              getValues={methods.getValues}
              reset={methods.reset}
            />
          </Box>
          <Box w={"115px"} textAlign={"center"}>
            <Text>~</Text>
          </Box>
          <Box sx={{ flex: 1 }}>
            <EDateRangePicker
              style={{ h: "30px" }}
              disabled={disabled}
              placeholder={FORMAT_DATE_PLACEHOLDER}
              dateFormat="yyyy-MM-dd"
              setValue={methods.setValue}
              control={methods.control}
              name={nameTo}
              getValues={methods.getValues}
              reset={methods.reset}
            />
          </Box>
        </Flex>
      </Flex>
    </GridItem>
  );
};

export default SearchEmployeeForm;
